import type { Tab, TabGroupProps } from '../tab-group';
import TabGroup from '../tab-group';

export type { Tab };
export type ToggleTabsProps = Omit<TabGroupProps, 'variant'>;

function ToggleTabs(props: ToggleTabsProps) {
  return <TabGroup variant="chip" {...props} />;
}

export default ToggleTabs;
